import { Formik, Form, Field, ErrorMessage } from "formik";
import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  useMemo,
} from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

import { addNotification } from "../../slices/notificationSlice";
import { showPromiseNotification } from "../../common/notification";
import { validateNoStartOrEndSpace } from "../../cutomValidationField";
import { UserListWithoutPaginate } from "../../apis/apiHandler";

import Select from "react-select";

const NotificationModel = ({ update, isOpen, onClose }) => {
  const dispatch = useDispatch();
  const modalRef = useRef(null);
  const [userList, setUserList] = useState([]);
  const [memberList, setMemberList] = useState([]);

  const fetchsUserList = async () => {
    const response = await UserListWithoutPaginate({type:"User"});
    if (response?.code === 1) {
      setUserList(response?.data);
    }
  };
const fetchMemberList = async () => {
    const response = await UserListWithoutPaginate({type:"Member"});
    if (response?.code === 1) {
      setMemberList(response?.data);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchsUserList();
      fetchMemberList();
    }
  }, [isOpen]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) document.addEventListener("mousedown", handleOutsideClick);
    else document.removeEventListener("mousedown", handleOutsideClick);

    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [isOpen, onClose]);

  // Initial Form Values
  const initialValues = useMemo(
    () => ({
      notification_type: "",
      title: "",
      message: "",
      selected_users: [],
      selected_members: [],
      name: update.status && update?.data ? update?.data?.name : "",
      main_category_id:
        update.status && update?.data ? update?.data?.main_category_id : "",
      points: update.status && update?.data ? update?.data?.points : "",
    }),
    [update]
  );

  // Form Validation
//   const validationSchema = Yup.object().shape({
//     notification_type: Yup.string().required("Please select notification type"),
//     title: Yup.string().required("Please enter title"),
//     message: Yup.string().required("Please enter message"),

//     selected_users: Yup.array()
//       .nullable()
//       .when("notification_type", (type, schema) => {
//         if (type === "selected_users") {
//           return schema.min(1, "Select at least one user");
//         }   
//         return schema; // always return schema → prevents "branch is not a function"
//       }),

//     selected_members: Yup.array()
//       .nullable()
//       .when("notification_type", (type, schema) => {
//         if (type === "selected_members") {
//           return schema.min(1, "Select at least one member");
//         }
//         return schema;
//       }),
//   });
  const validationSchema = Yup.object().shape({
    notification_type: Yup.string().required("Please sele ct notification type"),
    title: Yup.string()
      .required("Please enter title")
      .test('not-empty', 'Please enter title', value => value && value.trim().length > 0),
    message: Yup.string()
      .required("Please enter message")
      .test('not-empty', 'Please enter message', value => value && value.trim().length > 0),

    selected_users: Yup.array()
      .transform((v) => (Array.isArray(v) ? v : []))
      .when("notification_type", {
        is: (val) => val === "selected_users",
        then: (schema) =>
          schema.min(1, "Please select at least one user"),
        otherwise: (schema) =>
          schema.transform((v) => (Array.isArray(v) ? v : []))
      }),

    selected_members: Yup.array()
      .transform((v) => (Array.isArray(v) ? v : []))
      .when("notification_type", {
        is: (val) => val === "selected_members",
        then: (schema) =>
          schema.min(1, "Please select at least one member"),
        otherwise: (schema) =>
          schema.transform((v) => (Array.isArray(v) ? v : []))
      }),
  });


  // Submit Handler
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const myPromise = new Promise((resolve, reject) => {
        dispatch(
          addNotification({
            payload: {
              notification_type: values.notification_type,
              title: values.title,
              body: values.message,
              selected_user_ids:
                values.notification_type === "selected_users"
                    ? values.selected_users
                    : values.notification_type === "selected_members"
                    ? values.selected_members
                    : [],
            },
          })
        )
          .then((response) => {
            if (response.payload.code === 1) {
                resolve(response.payload);
        }
            else reject(response.payload);
          })
          .catch(reject);
      });

      showPromiseNotification(myPromise);
    } finally {
      setSubmitting(false);
      onClose();
    }
  };

  return (
    <>
      {isOpen && (
        <div
          className="modal fade show"
          tabIndex="-1"
          style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            ref={modalRef}
            style={{ minWidth: "40%" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" style={{ fontSize: "22px" }}>
                  {update.status ? "Edit Notification" : "Add Notification"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={onClose}
                ></button>
              </div>

              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ values, setFieldValue, isSubmitting, errors }) => (
                  <Form>
                    <div className="modal-body">
                      {/* NOTIFICATION TYPE */}
                      <div className="mb-3">
                        <label className="form-label">
                          <sup style={{ color: "red" }}>*</sup> Notification
                          Type
                        </label>

                        <Field
                          as="select"
                          name="notification_type"
                          className={`form-control ${
                            errors.notification_type ? "is-invalid" : ""
                          }`}
                        >
                          <option value="">Select Type</option>
                          <option value="notify_all">Notify All</option>
                          <option value="notify_all_users">
                            Notify All Users
                          </option>
                          <option value="notify_all_members">
                            Notify All Members
                          </option>
                          <option value="selected_users">Selected Users</option>
                          <option value="selected_members">
                            Selected Members
                          </option>
                        </Field>

                        <ErrorMessage
                          name="notification_type"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>

                      {/* TITLE */}
                      <div className="mb-3">
                        <label className="form-label">
                          <sup style={{ color: "red" }}>*</sup> Title
                        </label>
                        <Field
                          type="text"
                          name="title"
                          className={`form-control ${
                            errors.title ? "is-invalid" : ""
                          }`}
                          placeholder="Enter Notification Title"
                        />
                        <ErrorMessage
                          name="title"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>

                      {/* MESSAGE */}
                      <div className="mb-3">
                        <label className="form-label">
                          <sup style={{ color: "red" }}>*</sup> Message
                        </label>
                        <Field
                          as="textarea"
                          name="message"
                          rows="3"
                          className={`form-control ${
                            errors.message ? "is-invalid" : ""
                          }`}
                          placeholder="Enter Notification Message"
                        />
                        <ErrorMessage
                          name="message"
                          component="div"
                          className="invalid-feedback"
                        />
                      </div>

                      {/* SELECT USERS */}
                      {values.notification_type === "selected_users" && (
                        <div className="mb-3">
                          <label className="form-label">
                            <sup style={{ color: "red" }}>*</sup> Select Users
                          </label>

                          <Select
                            isMulti
                            name="selected_users"
                            options={userList.map((u) => ({
                              value: u.id,
                              label: u?.first_name+ ' ('+ u?.email+')',
                            }))}
                            onChange={(selected) =>
                              setFieldValue(
                                "selected_users",
                                selected.map((s) => s.value)
                              )
                            }
                          />
                          <ErrorMessage
                            name="selected_users"
                            component="div"
                            className="invalid-feedback d-block"
                          />
                        </div>
                      )}

                      {/* SELECT MEMBERS */}
                      {values.notification_type === "selected_members" && (
                        <div className="mb-3">
                          <label className="form-label">
                            <sup style={{ color: "red" }}>*</sup> Select Members
                          </label>

                          <Select
                            isMulti
                            name="selected_members"
                            options={memberList.map((m) => ({
                              value: m.id,
                              label: m?.first_name+ ' ('+ m?.email+')',
                            }))}
                            onChange={(selected) =>
                              setFieldValue(
                                "selected_members",
                                selected.map((s) => s.value)
                              )
                            }
                          />
                          <ErrorMessage
                            name="selected_members"
                            component="div"
                            className="invalid-feedback d-block"
                          />
                        </div>
                      )}
                    </div>

                    <div className="modal-footer">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                      >
                        {update.status ? "Update" : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onClose}
                      >
                        Close
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}

      {isOpen && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default NotificationModel;
